<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
} from 'devextreme-vue/data-grid';
import Loader from "@/router/views_mobagile/components/loader.vue";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader,
    Layout, PageHeader

  },
  data() {
    return {
      title: "Marketplace Transportadoras",
      items: [
        {
          text: "Transporte",
          href: "/"
        },
        {
          text: "Marketplace Transportadoras",
          active: true
        },
      ],
      updating: true,
      transportadorasList: []
    };
  },
  created() {

  },
  mounted() {
    this.carregarDados()

  },

  methods: {

    carregarDados() {
      console.log('carregarDados_Transp_Marketplace ')
      this.updating = true
      this.transportadorasList = [
        {
          id: 1,
          nome: 'Fitlog - ES (até 100kg)',
          logo: require(`@/assets/images/logotransp/31423169000188.png`),
          status: 'Ativa',
          data: '01/10/2025',
          contratada: 'S',
          regioes: ['ES', 'RJ', 'SP', 'MG'],
          email: 'comercial@fitlog.com.br',
          telefone: '(27) 3324-5500',
        },
        {
          id: 2,
          nome: 'Favorita - ES',
          logo: require(`@/assets/images/logotransp/01743404001290.png`),
          status: 'Inativa',
          data: '01/10/2025',
          contratada: 'N',
          regioes: ['ES', 'BA', 'MG', 'RJ', 'SP'],
          email: 'contato@favoritatransportes.com.br',
          telefone: '(27) 3336-2000',
        },
        {
          id: 3,
          nome: 'Generoso - ES',
          logo: require(`@/assets/images/logotransp/00972696000118.png`),
          status: 'Ativa',
          data: '01/10/2025',
          contratada: 'S',
          regioes: ['ES','RJ','SP', 'MG', 'BA', 'PR'],
          email: 'atendimento@transportegeneroso.com.br',
          telefone: '(27) 3320-4100',
        },
        {
          id: 4,
          nome: 'Translovato',
          logo: require(`@/assets/images/logotransp/89823918000225.png`),
          status: 'Ativa',
          data: '20/08/2025',
          contratada: 'S',
          regioes: ['ES','RJ','SP', 'MG', 'BA'],
          email: 'serra@translovato.com.br',
          telefone: '(27) 99749-4324',
        },
      ]
      this.updating = false
    },


    contratarTransp(transp){
      console.log('contratarTransp')
      console.log(transp)

    }

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 200px;">
    </Loader>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row mb-0">

              <div class="col-sm-4" v-for="transp in transportadorasList" :key="transp.id">
                <div class="card border">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start">
                      <div>
                        <h5 class="mb-0">{{ transp.nome }}</h5>
                        <span class="font-size-12 mt-2 badge"
                              :class="transp.status === 'Ativa' ? 'badge-soft-success' : 'badge-soft-danger'">
                          {{ transp.status }}
                        </span>
                        <p class="text-muted mt-2">
                          01/10/2025
                        </p>
                        <p class="text-black-50 mb-2">
                          <i class="mdi mdi-map-marker h3 text-warning align-middle mb-0 me-0"></i>
                          Regiões Atendidas:
                        </p>
                        <span class="badge badge-soft-dark font-size-12 mt-0 me-2" v-for="regiao in transp.regioes" :key="regiao" >
                          {{ regiao }}
                        </span>
                      </div>
                      <img
                          :src="transp.logo"
                          alt="Logo"
                          class="logo-transp"/>
                    </div>

                    <div class="d-flex align-items-center mt-3 text-black-50">
                      <span>
                        <i class="mdi mdi-mailbox-open h3 text-warning align-middle mb-0 me-0"></i>
                        {{ transp.email  }}
                      </span>
                      <span class="ms-auto">
                        {{ transp.telefone }}
                        <i class="mdi mdi-phone h3 text-warning align-middle mb-0 me-0"></i>
                      </span>
                    </div>

                    <div class="d-flex align-items-center mt-3 text-black-50">
                      <b-button v-if="transp.contratada === 'S'"
                                variant="warning"
                                size="md"
                                class="w-100"
                                @click="contratarTransp"
                                :disabled="true">
                        Contratado
                      </b-button>
                      <b-button variant="success" size="md" class="w-100" @click="contratarTransp" v-else>
                        Quero Contratar
                      </b-button>
                    </div>

                    <div class="d-flex align-items-center mt-3 text-black-50 ms-5 me-5">
                      <span>
                        <a href="javascript: void(0);"
                           class="text-black-50 text-wrap">
                          <i class="mdi mdi-link h3 text-black-50 align-middle mb-0 me-0"></i>
                          Integração via API
                        </a>
                      </span>
                      <span class="ms-auto">
                        <a href="javascript: void(0);"
                           class="text-black-50 text-wrap">
                          Incluir via Tabela
                          <i class="mdi mdi-plus-circle h3 text-black-50 align-middle mb-0 me-0"></i>
                        </a>
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style>

.logo-transp {
  width: 200px;
  height: 90px;
  object-fit: contain;
  border-radius: 50%;
}

</style>